import type { SVGProps } from 'react';
const SvgPhoneAndroid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#phone_android_svg__a)">
      <path
        fill="currentColor"
        d="M16 1H8C6.34 1 5 2.34 5 4v16c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3Zm-2 20h-4v-1h4v1Zm3.25-3H6.75V4h10.5v14Z"
      />
    </g>
    <defs>
      <clipPath id="phone_android_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPhoneAndroid;
